//#region src/chunk.ts
function chunk(array, size) {
	return Array.from({ length: Math.ceil(array.length / size) }, (_, i) => {
		return array.slice(i * size, (i + 1) * size);
	});
}
//#endregion
export { chunk };

//# sourceMappingURL=chunk.mjs.map